import type { Property } from "csstype";

/**
 * Sans-serif font
 *
 * @see https://zpl.io/V4ep7Jy
 */
export const base: Property.FontFamily = "'Source Sans Pro', sans-serif";

/**
 * Monospace font
 *
 * @see https://zpl.io/V4ep7Jy
 */
export const mono: Property.FontFamily = "'Source Code Pro', monospace";
